export const color = {
	redLight: '#F5B7C1',
	red: '#FF1E58',
	redMedium: '#FA6159',
	redDark: '#B3131B',
	green: '#76B64D',
	greenLight: '#8DFDC1',
	greenLight2: '#D3FBE1',
	greenMedium: '#42E9BD',
	greenDark: '#1AE0AC',
	purple: '#7059A5',
	blue: '#00578D',
	blueLight: '#99BCD1',
	blueDark: '#0abbcbff',
	orange: '#FD8700',
	yellow: '#FFEF35',
	yellowLight: '#FFF8BD',
	white: '#FFFFFF',
	black: '#000000',
	grayLight: '#fbfbfb',
	gray: '#4A4A49',
	grayMedium: '#dbdbdb',
	grayDark: '#929292',
	primary: '#42E9BD',
	secondary: '#0AD6EA',
	softBlack: '#333333',
	modalGreen: '#D3FBE1'
};
